import { Component, Input, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-modal-votacion',
  templateUrl: './modal-votacion.component.html',
  styleUrls: ['./modal-votacion.component.css']
})
export class ModalVotacionComponent implements OnInit {

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig) { }
  
  ngOnInit(): void {
    console.log('data modal', this.config.data)
  }

  cerrar(id){
    this.ref.close({id: id});
  }

}
